// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g4tI","type":"styles_type__2XCEh","choices":"styles_choices__KrlkI"};